import PropTypes from 'prop-types';
import { Icon } from '@iconify/react';
import { useState, useEffect, useRef } from 'react';

import searchFill from '@iconify/icons-eva/search-fill';
// material
import { experimentalStyled as styled } from '@material-ui/core/styles';
import { Box, Link, TextField, Typography, Autocomplete, InputAdornment } from '@material-ui/core';


// ----------------------------------------------------------------------

const RootStyle = styled('div')(({ theme }) => ({
  '& .MuiAutocomplete-root': {
    width: 200,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.easeInOut,
      duration: theme.transitions.duration.shorter
    }),
    '&.Mui-focused': {
      width: 240,
      '& .MuiAutocomplete-inputRoot': {
        boxShadow: theme.customShadows.z12
      }
    }
  },
  '& .MuiAutocomplete-inputRoot': {
    '& fieldset': {
      borderWidth: `1px !important`,
      borderColor: `${theme.palette.grey[500_32]} !important`
    }
  },
  '& .MuiAutocomplete-option': {
    '&:not(:last-child)': {
      borderBottom: `solid 1px ${theme.palette.divider}`
    }
  },
  '& .Mui-error .MuiOutlinedInput-notchedOutline': {
    borderColor: `${theme.palette.error.main} !important`
  }
}));

// ----------------------------------------------------------------------

OfficialRequestSearch.propTypes = {
  sx: PropTypes.object
};

export default function  OfficialRequestSearch({
   sx,setSearching,searching
  }) {
    const [error, setError] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const debounceTimeoutRef = useRef(null);
    
    // Debounced search function
    const debouncedSearch = (value) => {
      if (debounceTimeoutRef.current) {
        clearTimeout(debounceTimeoutRef.current);
      }
      
      debounceTimeoutRef.current = setTimeout(() => {
        setSearching(value);
      }, 500); // 500ms delay
    };
    
    const handleChangeSearch = async(event, value) => {
      const wordCount = value.trim().split(/\s+/).filter(Boolean).length;
      if (wordCount <= 25) {
        setError(false);
        if(event){
          // Use debounced search instead of immediate setSearching
          debouncedSearch(event.target.value);
        }
      } else {
        setError(true);
      }
    };

    // Cleanup timeout on unmount
    useEffect(() => {
      return () => {
        if (debounceTimeoutRef.current) {
          clearTimeout(debounceTimeoutRef.current);
        }
      };
    }, []);

  return (
    <RootStyle
      sx={{
        ...(!searchQuery && {
          '& .MuiAutocomplete-noOptions': {
            display: 'none'
          }
        }),
        ...sx
      }}
    >
      <Autocomplete
        open
        size="small"
        disablePortal
        popupIcon={null}
        options={[]}
        onInputChange={handleChangeSearch}
         value={searching}
          noOptionsText={null}
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder={"Search..."}
            error={error}
            helperText={error ? 'Maximum 25 words allowed.' : ''}
            InputProps={{
              ...params.InputProps,
              startAdornment: (
                <>
                  <InputAdornment position="start">
                    <Box
                      component={Icon}
                      icon={searchFill}
                      sx={{
                        ml: 1,
                        width: 20,
                        height: 20,
                        color: 'text.disabled'
                      }}
                    />
                  </InputAdornment>
                  {params.InputProps.startAdornment}
                </>
              )
            }}
          />
        )}
       
      />
    </RootStyle>
  );
}
